module.exports = __webpack_public_path__ + "img/flag_236.4bf1d576.png";